window.addEventListener("load", function () {
  if ($("#swiperCharacter").length > 0) {
    // Function to load images

    const thumbsSwiper = new Swiper("#swiperCharacterThumb", {
      slidesPerView: 6,
      spaceBetween: 10,
      // centeredSlides: true,
      slideToClickedSlide: true,
      breakpoints: {
        751: {
          slidesPerView: 6,
        },
      },
    });

    const mainSwiper = new Swiper("#swiperCharacter", {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 0,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
      navigation: {
        nextEl: ".swiper-button-next--swiperCharacter",
        prevEl: ".swiper-button-prev--swiperCharacter",
      },
      on: {
        slideChangeTransitionStart: function () {
          var $character = $(this.slides[this.activeIndex]).find(".character");
          if ($character.length) {
            $character.css("animation", "none");
            $character[0].offsetHeight; // trigger reflow
            $character.css("animation", "");
          }
        },
      },
    });
  }
});
